// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/portfolio-configuration/app/css/app.css
// module id = 834
// module chunks = 0